<div class="loading-overlay" [ngClass]="overlayClass">
    <mat-spinner class="loading-overlay__spinner" [color]="color" [diameter]="diameter"></mat-spinner>
</div>
